import { h, defineComponent, provide } from 'vue'
import { getComponent } from './componentTypes'
import { useForm } from '@/composables/useForm'
import type { Page } from '@/types'

export default defineComponent({
  name: 'QuestionnaireForm',
  props: {
    rawSchema: {
      type: Array as () => Page[],
      required: true,
      default: () => []
    },
    metaData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  setup(props) {
    const {
      formState,
      validateField,
      onSubmit,
      back,
      next,
      jumpToField,
      setToLastField,
      getFieldByUuid,
      updateField,
      fields
    } = useForm(props.rawSchema)

    const handleFieldChange = (uuid: string, value: any) => {
      updateField(uuid, value)
    }

    // Provide the vueform object
    provide('vueform', {
      formState,
      validateField,
      onSubmit,
      back,
      handleFieldChange
    })

    return () =>
      h(getComponent('formTemplate'), {
        formFields: fields,
        metaData: {
          ...props.metaData,
          activeField: formState.value.activeFieldId,
          isLastField: formState.value.isLastField,
          isFirstField: formState.value.isFirstField
        },
        rawSchema: props.rawSchema,
        formState: formState.value,
        validateField,
        onSubmit,
        back,
        next,
        jumpToField,
        setToLastField,
        getFieldByUuid,
        handleFieldChange
      })
  }
})
